import React from 'react'
import ReactDOM from 'react-dom/client'
import KdApp from './kd/KdApp'
import './index.css'

// Phase 1 Supabase : nouvelle application dans src/kd/.
// L'ancienne (src/App.tsx + serveur maison) est conservée mais n'est plus lancée.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <KdApp />
  </React.StrictMode>,
)
